import axios from 'axios'

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASEURL
})

// const HEADERS = {
//     'Content-Type': 'application/json'
// };

export async function postUploadPhotoProfile(file, dispatch) {
    const AuthToken = 'Bearer '.concat(localStorage.getItem(process.env.REACT_APP_TOKENUSER));
    var formData = new FormData();
    formData.append('file', file)

    dispatch({ type: 'OPEN_LOADING' })
    await http.post('/account/uploadphotoprofile',
        formData,
        {
            headers: {
                'Authorization': AuthToken
            }
        }).then(response => {
            successPostUploadPhotoProfile(response, dispatch);
        }).catch(erro => {
            erropostUploadPhotoProfile(erro.response, dispatch);
        })
    dispatch({ type: 'CLOSE_LOADING' })
};

function successPostUploadPhotoProfile(response, dispatch) {
    if (response.data.uri) {
        dispatch({
            type: 'SETURI_FOTOPERFIL',
            uri: response.data.uri
        })
    }
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Foto',
        description: 'Foto cadastrada com sucesso'
    })
}

function erropostUploadPhotoProfile(erro, dispatch) {
    dispatch({
        type: 'OPEN_ALERT_DIALOG',
        title: 'Foto',
        description: 'Houve um erro ao tentar enviar os dados'
    })
}